<template>
  <div>
    <abstractTable
      :data="TransactionStatus"
      :definitionTable="true"
      :definitionTableWidth="'16%'"
      :classes="'ui compact definition table'"
      v-if="lastReservationsTransactions.length > 0"
    />
    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No Transactions have been made yet
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default
  },
  props: {
    lastReservationsTransactions: { type: Array, required: true}
  },
  computed: {
    TransactionStatus() {
      const totalDebit = window._.sumBy(this.lastReservationsTransactions, rTransaction => {
        return Number(rTransaction.debit)
      })
      const totalCredit = window._.sumBy(this.lastReservationsTransactions, rTransaction => {
        return Number(rTransaction.credit)
      })

      const remainder = totalCredit - totalDebit

      return {
        debit: this.formatPrice(remainder > 0 ? 0 : -1 * remainder),
        credit: this.formatPrice(remainder > 0 ? remainder : 0)
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/applications_components/TransactionStatus.vue